<template>
  <div>
    <div class="column">
      <div class="radio-wrap-vertical">
        <div v-for="(coupon, index) in myCoupon" :key="index">
          <div :class="[isAvailable(coupon) ? 'radio' : 'radio-disabled']">
            <input
              :id="'radio-' + index"
              v-model="selectedCoupon"
              :disabled="!isAvailable(coupon)"
              name="radio"
              type="radio"
              :value="String(coupon.id)"
            />
            <label :for="'radio-' + index" class="radio-label">
              {{ coupon.name }}
            </label>
          </div>
        </div>
        <div class="radio">
          <input
            id="radio-none"
            v-model="selectedCoupon"
            name="radio-none"
            type="radio"
            value="none"
          />
          <label for="radio-none" class="radio-label">
            引換券を使用しない
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";

export default {
  name: "MFITTCouponList",
  props: {
    myCoupon: {
      type: Object,
      required: true,
    },
    selectedCoupon: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const selectedCoupon = useVModel(props, "selectedCoupon");

    const isAvailable = (coupon) => {
      if (
        coupon.is_exchangeable &&
        coupon.allowed_from_stations.length > 0 &&
        coupon.allowed_to_stations.length > 0 &&
        coupon.used_count < coupon.use_limit
      ) {
        return true;
      } else {
        return false;
      }
    };

    return {
      selectedCoupon,
      isAvailable,
    };
  },
};
</script>

<style lang="scss" scoped>
/* ラジオボタン */
.radio {
  margin: 1.5rem !important;
  font-size: 14px;
}

.radio-disabled {
  margin: 1.5rem !important;
  font-size: 14px;
  color: #b4b4b4;
}

.radio-wrap-vertical {
  /* Listの下端とボタンが重ならないようにfoot-button-blockの縦幅分だけ余白を挿入 */
  padding-bottom: 95px;
}

.radio input[type="radio"],
.radio-disabled input[type="radio"] {
  position: absolute;
  opacity: 0;
}

.radio input[type="radio"] + .radio-label:before,
.radio-disabled input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type="radio"]:checked + .radio-label:before,
.radio-disabled input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type="radio"]:focus + .radio-label:before,
.radio-disabled input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}
.radio input[type="radio"]:disabled + .radio-label:before,
.radio-disabled input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type="radio"] + .radio-label:empty:before,
.radio-disabled input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}
</style>
